import { createSelector } from '@reduxjs/toolkit'

export const types = ({ types }) => types

export const fontTypesSelector = createSelector(
  types,
  ({ fontTypes }) => fontTypes
)

export const uniqueFontTypesSelector = createSelector(types, ({ fontTypes }) =>
  fontTypes.filter(
    ({ fontStyle, fontWeight }) => fontStyle === 'normal' && fontWeight === 400
  )
)
